import React from 'react'
import { usePortal } from '../hooks/usePortal'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import { useAxios } from '../hooks/useAxios'
import { getPrizes } from '../api/getPrizes'
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import PrizeCard from '../components/PrizeCard'

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Награды',
    path: '/rewards'
  },
  {
    label: 'Витрина призов',
    path: '/rewards/prizes'
  }
]

const PrizesPage: React.FC<any> = () => {
  const {
    response: prizes,
    loading: prizesLoading,
    fire: prizesFire
  } = useAxios()

  React.useEffect(() => {
    prizesFire(getPrizes()).catch((e: any) => {
      toast.error(e)
    })
  }, [])

  const { portal } = usePortal()

  return (
    <div className={'page'}>
      <Breadcrumbs className={'page__breadcrumbs'} breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(
          <Breadcrumbs breadcrumbs={BREADCRUMBS}></Breadcrumbs>,
          portal
        )}

      <header className="page__head">
        <h1>Витрина призов</h1>
      </header>

      <div className="page__content prizes">
        {prizes?.data?.length || prizesLoading ? (
          <>
            {prizesLoading ? (
              <>
                {Array.from({ length: 10 }).map((_, i) => (
                  <div key={i}>
                    <Skeleton
                      height={'32rem'}
                      borderRadius={'3.2rem'}
                    ></Skeleton>
                  </div>
                ))}
              </>
            ) : (
              <>
                {prizes?.data?.map((prize: any) => (
                  <PrizeCard {...prize} key={prize.id}></PrizeCard>
                ))}
              </>
            )}
          </>
        ) : (
          'Нет данных'
        )}
      </div>
    </div>
  )
}

export default PrizesPage
